import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

/**
 * Recherche des utilisateurs BO *existants* n'ayant pas encore l'accès Prométhée.
 * Sert au flux "Ajouter un utilisateur" : on rattache un compte BO existant,
 * on ne crée jamais de nouveau compte depuis Prométhée.
 */
const fetchAvailableUsers = async (search) => {
  const { data } = await axiosInstance.get(
    '/promethee_admin/users/available/',
    {
      params: search ? { search } : {},
    }
  );
  return data; // tableau [{ id, email, username, first_name, last_name, is_active }]
};

export const useGetAvailableUsers = (search = '', options = {}) =>
  useQuery({
    queryKey: ['admin', 'available-users', search],
    queryFn: () => fetchAvailableUsers(search),
    enabled: options.enabled ?? true,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  });
